// Service page content for Student visa (Subclass 500).
// Sourced from docs/research/australian-visa-pathways.md §5.
// COMPLIANCE: admissions and OSHC are our lane; we prepare and organise the
// file. A registered migration agent gives the migration advice, confirms
// requirements, and lodges. No guaranteed outcomes; honest that study is an
// indirect, non-guaranteed route to PR; no unverified figures stated as fact.

const student500 = {
  groupSlug: "student-graduate",
  slug: "student-500",
  title: "Student Visa (Subclass 500)",
  eyebrow: "Student & Graduate",
  intro:
    "The Subclass 500 lets you study full time in Australia in a registered course. One visa can cover you and your family, and it can open the door to a graduate visa and beyond. The keys are a genuine plan to study, the funds to support yourself, and getting the application right the first time.",

  chips: [
    { label: "Visa type", value: "Temporary, study" },
    { label: "Requires", value: "A CRICOS course enrolment" },
    { label: "Key test", value: "Genuine Student requirement" },
    { label: "Includes", value: "You and eligible family" },
  ],

  whoFor: [
    "International students enrolled in, or applying for, a registered (CRICOS) course.",
    "Students who need to evidence genuine study intentions and financial capacity.",
    "People who may want to study now and explore graduate or skilled pathways later.",
  ],

  essentials: [
    {
      title: "A Confirmation of Enrolment",
      detail:
        "You need a Confirmation of Enrolment in a registered (CRICOS) course before you can lodge.",
    },
    {
      title: "The Genuine Student requirement",
      detail:
        "You answer targeted questions showing a genuine intention to study. This replaced the former Genuine Temporary Entrant requirement.",
    },
    {
      title: "Evidence of financial capacity",
      detail:
        "You must show you can cover course fees, living costs, and travel. The required savings figure is set by the government and is updated, so a registered migration agent confirms the current amount.",
    },
    {
      title: "English language",
      detail:
        "Minimum English scores apply and were tightened recently. A registered migration agent confirms the current requirement for your course.",
    },
    {
      title: "Overseas Student Health Cover",
      detail:
        "OSHC is mandatory for the full visa period. We help you arrange it.",
    },
    {
      title: "Work limits while studying",
      detail:
        "Work is capped while your course is in session and unlimited during scheduled breaks. A registered migration agent confirms the current rule so you stay compliant.",
    },
  ],

  process: [
    {
      title: "Plan your study",
      detail:
        "We help you choose a genuine, suitable course and provider, working with our admissions support.",
    },
    {
      title: "Prepare your evidence",
      detail:
        "We help you assemble enrolment, financial, and English evidence and prepare your Genuine Student responses.",
    },
    {
      title: "Arrange OSHC",
      detail: "We help you put the required health cover in place.",
    },
    {
      title: "Lodge the application",
      detail:
        "We prepare and organise a thorough file, and a registered migration agent lodges it and deals with the Department.",
    },
    {
      title: "Decision and beyond",
      detail:
        "The Department decides. Once you are studying, a registered migration agent can advise on graduate and skilled pathways, and we keep your documentation organised.",
    },
  ],

  faqs: [
    {
      q: "What is the Genuine Student requirement?",
      a: "It is the test that you genuinely intend to study, answered through targeted questions in your application. It replaced the older Genuine Temporary Entrant requirement, and the focus is on a genuine study plan rather than promising you will leave.",
    },
    {
      q: "How much money do I need to show?",
      a: "You must evidence enough to cover course fees, living costs, and travel. The minimum savings figure is set by the government and has risen over time, so a registered migration agent confirms the current amount for you rather than quoting an outdated number.",
    },
    {
      q: "Can I work on a student visa?",
      a: "Yes, within limits. Work is capped while your course is in session and unlimited during scheduled course breaks. A registered migration agent confirms the current cap so you do not breach your visa conditions.",
    },
    {
      q: "Does studying lead to permanent residence?",
      a: "Not directly. A student visa is temporary. Many students move to a graduate (485) visa and then skilled or employer-sponsored routes, but that is an indirect path with no guarantees. We are upfront about that so you plan realistically, and a registered migration agent advises on the pathway that fits you.",
    },
  ],

  related: ["graduate-485", "oshc", "admissions"],

  lastVerified: "13 July 2026",
};

export default student500;
